<template>
    <div>
      <p><NuxtLink :to="`/orgs/${org._id}`" class="">Back to {{org.name}}</NuxtLink>
      </p>
  
      <h2
        class="text-6xl font-extrabold leading-none tracking-tight text-gray-900 dark:text-white"
      >
        {{ org.name }}
      </h2>
      
      <Section>
        <div class="text-2xl font-bold mb-5">
          Profiles
          <CreateProfile :org="org" />
          
        </div>
  
        <ImportProfileFromUrl :org="org" />
        <ProfilesTable :org="org" />
        <p v-if="loading">Loading profiles...</p>
      
      </Section>
  
     
    </div>
  </template>
  
  <script setup lang="ts">
  import { useOrgStore, useProfileStore } from "~/store";
  import Section from "~/components/Section.vue";
  import CreateProfile from "~/features/profiles/CreateProfile.vue";
  import ProfilesTable from "~/features/profiles/ProfilesTable.vue";
  import ImportProfileFromUrl from "~/features/profiles/ImportProfileFromUrl.vue";
  
  const orgStore = useOrgStore();
  const route = useRoute();
  const orgId = route.params.orgId;
  if (!orgId) throw new Error("orgId is required");
  const org = computed(() => orgStore.getOrg(orgId as any));
  const loading = ref(true);
  
  useProfileStore().fetchData().then(() => {
    loading.value = false;
  });
  </script>
  
  <style scoped>
  /* CSS specific to this page */
  </style>
  